import { HasEmphasis } from '@/modules/surgicalEvent';

export interface MedicalOption extends HasEmphasis {
  code: string;
  translationCode: string;
}

export type MedicalOptionGroups = {
  [key in MedicalOptionGroupCode]?: MedicalOption[];
};

/**
 * Every option group the BFF sends, used or not: loading the options fails on a group missing here.
 */
export enum MedicalOptionGroupCode {
  EMERGENCY = 'emergency',
  ASA_SCORE = 'asaScore',
  PATIENT_RISK_SCORE = 'patientRiskScore',
  ASPIRATION_RISK = 'aspirationRisk',
  AUSCULTATION = 'auscultation',
  BACKBONE = 'backbone',
  BEARD = 'beard',
  MOUTH_OPENING = 'mouthOpening',
  BLOOD_EXTENSION_TIME = 'bloodExtensionTime',
  BLOOD_GROUP = 'bloodGroup',
  CARDIO = 'cardio',
  CARE_TYPE = 'careType',
  CESAREAN_RISK = 'cesareanRisk',
  DELIRIUM_RISK = 'deliriumRisk',
  DENTAL_CONDITION = 'dentalCondition',
  DENTAL_RISK = 'dentalRisk',
  DIFFICULT_VENTILATION_HO = 'difficultVentilationHo',
  DTM = 'dtm',
  EPIDURAL = 'epidural',
  EPIDURAL_HO = 'epiduralHo',
  FOETUS_POSITION = 'foetusPosition',
  GA_AIRWAY_TYPE = 'gaAirwayType',
  HEMORRHAGE_RISK = 'hemorrhageRisk',
  HYPOTENSION_RISK = 'hypotensionRisk',
  INTUBATION_RISK = 'intubationRisk',
  TRANSFUSION_RISK = 'transfusionRisk',
  KIDNEY_RISK = 'kidneyRisk',
  CARDIAC_RISK = 'cardiacRisk',
  HEPATIC_RISK = 'hepaticRisk',
  INFECTION_RISK = 'infectionRisk',
  POST_OP_PAIN_RISK = 'postOpPainRisk',
  PHLEBITIS_RISK = 'phlebitisRisk',
  ALLERGY_RISK = 'allergyRisk',
  LIP_TEST = 'lipTest',
  MALLAMPATI_SCORE = 'mallampatiScore',
  CERVICAL_MOBILITY = 'cervicalMobility',
  MOUTH_MOBILITY = 'mouthMobility',
  NO_TEETH = 'noTeeth',
  PLACENTA_POSITION = 'placentaPosition',
  PONV_PREVENTION = 'ponvPrevention',
  PONV_RISK = 'ponvRisk',
  PREGNANCY_STATUS = 'pregnancyStatus',
  PREOP_VENTILATION = 'preopVentilation',
  RAI = 'rai',
  RECOMMENDED_AIRWAY_STRATEGY = 'recommendedAirwayStrategy',
  RESPIRATORY = 'respiratory',
  RHESUS = 'rhesus',
  SNORING = 'snoring',
  SURGERY_POSITION = 'surgeryPosition',
  SURGERY_RISK = 'surgeryRisk',
  VENTILATION_RISK = 'ventilationRisk',
  POSTOP_BLEEDING = 'postopBleedingLevel',
  POSTOP_PONV = 'postopPonvLevel',
  TIME_OF_DAY = 'timeOfDay',
  UNEXPECTED_HOSPITALIZATION = 'unexpectedHospitalization',
  AMBULATORY = 'ambulatory',
  CURRENT_PREGNANCY_COMPLICATIONS = 'currentPregnancyComplications',
  PREVIOUS_PREGNANCY_COMPLICATIONS = 'previousPregnancyComplications',
  CHRONIC_PAIN_DIAGNOSIS = 'chronicPainDiagnosis',
  CHRONIC_PAIN_OPIOIDS = 'chronicPainOpioids'
}
